/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import AccordianItem from "./AccordianItem";

export {
  AccordianItem
};
